export enum UserType {
  Initiated = 0,
  Resident = 1,
  CommunityMember = 2,
  ResidentPending = 3,
  Other,
}
